import axios from 'axios'
import { store } from 'src/client'
import { selectAuthedJsonApiRequestConfig } from 'src/redux/selectors/axios.selectors'

interface G2ReviewTokenResponse {
  reviewEmbedUrl: string
}

export const fetchG2Token = async (): Promise<G2ReviewTokenResponse> => {
  const state = store.getState()
  const requestConfig = selectAuthedJsonApiRequestConfig(state)

  const response = await axios.post<G2ReviewTokenResponse>(
    '/g2-review-token',
    undefined,
    requestConfig,
  )
  return response.data
}
